module.exports = __webpack_public_path__ + "static/media/nov 2021.d22c333f.svg";